import React, { createContext, useState, useEffect, useContext } from "react";
import { fetchRolByEmail } from "../Api/fetchAdmin";

const RoleContext = createContext(null);

const getRol = async (userEmail) => {
  if (!userEmail) {
    console.warn("getRol: No se proporcionó un email de usuario.");
    return null;
  }
  try {
    const response = await fetchRolByEmail(userEmail);
    console.log(
      "getRol (Context) - response.data.body.data for email",
      userEmail,
      ":",
      response.data.body.data
    );
    const result = response.data.body.data;
    return !result ? "unidad" : result;
  } catch (error) {
    console.error(
      "Error en getRol (Context) al llamar a fetchDivisionalByEmaiil con email:",
      userEmail,
      error
    );
    return null;
  }
};

export const RoleProvider = ({ children, authenticatedUserEmail }) => {
  const [userRol, setUserRol] = useState(null);
  const [loadingRol, setLoadingRol] = useState(true);
  const [userEmail, setUserEmail] = useState(true);

  useEffect(() => {
    console.log("authenticatedUserEmail", authenticatedUserEmail);
    const loadRol = async () => {
      if (authenticatedUserEmail) {
        try {
          setUserEmail(authenticatedUserEmail);
          const rol = await getRol(authenticatedUserEmail);
          setUserRol(rol);
        } catch (error) {
          console.error("Error al cargar el rol en el contexto:", error);
        } finally {
          setLoadingRol(false);
        }
      } else {
        console.log("RoleProvider: No authenticated email available yet.");
        setUserRol("unidad");
        setLoadingRol(false);
      }
    };

    setLoadingRol(true);
    loadRol();
  }, [authenticatedUserEmail]);

  return (
    <RoleContext.Provider value={{ userRol, loadingRol, userEmail }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => {
  const context = useContext(RoleContext);
  if (context === undefined) {
    throw new Error("useRole must be used within a RoleProvider");
  }
  return context;
};
